export const MILESTONE_WIDTH = 155;
export const MILESTONE_HEIGHT = 40;
export const BOARD_MARGIN_LEFT = 42;
export const milestoneOffset = position => {
  return Math.max(0, position);
};
export const milestoneDateMarkerOffset = 20;
